import { message } from "antd";
import { makeObservable, observable } from "mobx";
import { get, post } from "../../services/request";
import {
  OFF_USER,
  OPEN_USER,
  USER_LIST,
  GET_ROLE_LIST,
  GET_USERISROLE,
  EDIT_USERISROLE,
  GET_ACCOUNT,
  BIND_ACCOUNT,
  EDIT_ACCOUNT,
  REMOVE_ACCOUNT,
  OPEN_ADMIN,
  OFF_ADMIN,
  REMOVE_USER,
} from "../../services/request/urls";
export interface RoleInfo {
  id: number;
  name: string;
  code: string;
  des: string;
  key: string;
}
export interface UserInfo {
  id: number;
  account: string;
  name: string;
  phone: string;
  gender?: number;
  avatoar?: string;
  status: number;
  roleName: string;
  orAdmin: number;
}
export interface AccountInfo {
  key: string;
  account: string | null;
  name: string;
  phone: string;
  isEmpty?: boolean;
}
export interface Pagination {
  total: number;
  pageSize: number;
  pageNum: number;
}
class UserStore {
  users?: UserInfo[];
  pagination: Pagination = {
    total: 0,
    pageSize: 10,
    pageNum: 1,
  };
  roleList: RoleInfo[] = [];
  userIsRoleList: { roleId: number; roleName: string }[] = [];
  userIsRoleListDefault: string[] = [];
  accountList: AccountInfo[] = [];
  constructor() {
    makeObservable(this, {
      users: observable,
      roleList: observable,
      userIsRoleList: observable,
      userIsRoleListDefault: observable,
      accountList: observable,
    });
  }
  setPagination(obj: Pagination) {
    this.pagination = { ...this.pagination, ...obj };
  }
  async getUserList(pageNo: number = 1, pageSize: number = 10, keyword?: string) {
    const res = await get(USER_LIST, { pageNo, pageSize, keyword: keyword || undefined }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取用户列表失败");
      return;
    }

    res.rows.map((item: RoleInfo, index: number, arr: RoleInfo[]) => {
      arr[index].key = String(arr[index].id);
    });
    this.users = res.rows;
    this.setPagination({
      ...this.pagination,
      total: res.total || 0,
    });
  }

  async getRoleList() {
    const res = await get(GET_ROLE_LIST, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取分组列表失败");
      return;
    }

    this.roleList = res.rows;
  }
  async getUserisRole(account: string) {
    const res = await get(GET_USERISROLE, { account }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取当前用户所属分组失败");
      return;
    }

    this.userIsRoleList = res.data;
    this.userIsRoleListDefault = [...this.userIsRoleList.map((item) => item.roleName)];
  }
  async editUserIsRole(account: string, arr: string[]) {
    const tmpArr = this.userIsRoleList.map((item) => item.roleName);
    const obj = {
      account,
      add: [...arr]
        .filter((item) => !tmpArr.includes(item))
        .map((item) => this.roleList.filter((i) => i.name === item)[0].id),
      del: [...tmpArr]
        .filter((item) => !arr.includes(item))
        .map((item) => this.roleList.filter((i) => i.name === item)[0].id),
    };

    const res = await post(EDIT_USERISROLE, obj, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "分组分配失败");
      return;
    }
    message.success("分组分配成功");
  }
  async removeUser(id: number) {
    const res = await post(`${REMOVE_USER}?id=${id}`, { id }, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "用户删除失败");
      return;
    }
    message.success("用户删除成功");

    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    await this.getUserList(this.pagination.pageNum, this.pagination.pageSize);
  }
  async offUser(id: number) {
    const res = await post(`${OFF_USER}?id=${id}`, null, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "用户禁用失败");
      return;
    }
    message.success("用户禁用成功");

    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    await this.getUserList(this.pagination.pageNum, this.pagination.pageSize);
  }
  async openUser(id: number) {
    const res = await post(`${OPEN_USER}?id=${id}`, null, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "用户启用失败");
      return;
    }
    message.success("用户启用成功");

    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    await this.getUserList(this.pagination.pageNum, this.pagination.pageSize);
  }
  async offAdmin(id: number) {
    const res = await post(`${OFF_ADMIN}?id=${id}`, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "关闭管理员权限失败");
      return;
    }
    message.success("关闭管理员权限成功");

    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    await this.getUserList(this.pagination.pageNum, this.pagination.pageSize);
  }

  async openAdmin(id: number) {
    const res = await post(`${OPEN_ADMIN}?id=${id}`, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "开启管理员权限失败");
      return;
    }
    message.success("开启管理员权限成功");
    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    await this.getUserList(this.pagination.pageNum, this.pagination.pageSize);
  }

  async getAccountList(phone: string, name: string = "") {
    const res = await post(GET_ACCOUNT, { phone, name }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取子系统账号列表失败");
      return;
    }
    this.accountList = res.data.map((item: AccountInfo) => {
      return { ...item, isEmpty: !!!item.account };
    });
  }
  async bindAccount(key: string, account: string, phone: string) {
    const res = await post(BIND_ACCOUNT, { key, account, phone }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "绑定子系统账号失败");
      return;
    }
    message.success("绑定成功");
    await this.getAccountList(phone);
  }
  async editAccount(key: string, account: string, phone: string) {
    const res = await post(EDIT_ACCOUNT, { key, account, phone }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑子系统账号失败");
      return;
    }
    message.success("编辑成功");
    await this.getAccountList(phone);
  }
  async removeAccount(key: string, phone: string) {
    const res = await post(REMOVE_ACCOUNT, { key, phone }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "删除子系统账号失败");
      return;
    }
    message.success("删除成功");
    await this.getAccountList(phone);
  }
}

export default new UserStore();
